export const getNumberOfPages = (rowCount: number, rowsPerPage: number): number => {
  if (rowCount < 1) return 1;
  return Math.ceil(rowCount / rowsPerPage);
};

export const currentRowsDisplayed = (currentPage: number, rowCount: number, rowsPerPage: number): [number, number] => {
  if (rowCount < 1) return [0, 0];
  const start = (currentPage - 1) * rowsPerPage + 1;
  const end = rowCount < currentPage * rowsPerPage ? rowCount : currentPage * rowsPerPage;
  return [start, end];
};
